import { Head } from '@inertiajs/react';
import { MainLayout } from '../../layouts/MainLayout';
import { VerduHero } from '../../components/verdu-landing/VerduHero';
import { SocialProof } from '../../components/verdu-landing/SocialProof';
import { ProblemSection } from '../../components/verdu-landing/ProblemSection';
import { TimeSavings } from '../../components/verdu-landing/TimeSavings';
import { WeeklyPredictions } from '../../components/verdu-landing/WeeklyPredictions';
import { Professionalize } from '../../components/verdu-landing/Professionalize';
import { TargetAudience } from '../../components/verdu-landing/TargetAudience';
import { VerduProducts } from '../../components/verdu-landing/VerduProducts';
import { FinalCTA } from '../../components/verdu-landing/FinalCTA';
import { SEOBlock } from '../../components/verdu-landing/SEOBlock';
import type { VerduLandingProps } from '../../types/verdu-landing';

export default function VerduLanding({ stats, featuredProducts, appUrl, loginUrl, whatsappUrl, mayoristaPlusDiscount }: VerduLandingProps) {
  return (
    <MainLayout>
      <Head>
        <title>Proveedor Mayorista para Verdulerías en Córdoba | Abasto Virtual</title>
        <meta
          name="description"
          content="Frutas y verduras al por mayor para tu verdulería. Ahorrá 15hs semanales, recibí predicciones de precios y delivery en tu local. Córdoba."
        />
        <link rel="canonical" href={`${appUrl}/verdulerias`} />
      </Head>

      <VerduHero loginUrl={loginUrl} whatsappUrl={whatsappUrl} promoDiscount={mayoristaPlusDiscount} />
      <SocialProof stats={stats} />
      <ProblemSection />
      <TimeSavings />
      <WeeklyPredictions />
      <Professionalize />
      <TargetAudience />
      <VerduProducts products={featuredProducts} />
      <FinalCTA loginUrl={loginUrl} whatsappUrl={whatsappUrl} promoDiscount={mayoristaPlusDiscount} />
      <SEOBlock appUrl={appUrl} />
    </MainLayout>
  );
}
